export const environment = {
    production: false,
    apiUrl: 'https://supreme-motors-api.scrabix.com/api/v1',
    websiteURL: 'https://supreme-motors.scrabix.com'
};

console.log('Staging environment loaded:', environment);
